import React from 'react';

export interface CoverImageProps {
  image?: string;
  price?: string;
  title?: string;
}

export const CoverImageDetails: React.FC<CoverImageProps> = ({
  image,
  price,
  title,
}) => {
  return (
    //
    <div className="food-cover-image">
      <div className="cover-image-overlay" />
      <div
        style={{
          backgroundImage: `url(${image})`,
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          // height: '300px',
          borderRadius: '10px',
        }}
        className="food-image"
      />
      <div className="cover-image-bottomleft-items">
        <span>{title}</span>
      </div>
      <div className="cover-image-bottom-items">
        <span>{`Kč ${price}.00`}</span>
      </div>
    </div>
  );
};
